import { motion } from "framer-motion";

const INTERIOR_IMG =
  "https://customer-assets.emergentagent.com/job_wedding-wheels-sk/artifacts/bah0tvp1_IMG_2757.jpeg";

const stats = [
  { value: "1962", label: "Ročník výroby" },
  { value: "V8", label: "Vzduchom chladený motor" },
  { value: "100%", label: "Pôvodný stav" },
  { value: "1 ks", label: "Jediná v ponuke" },
];

export default function About() {
  return (
    <section
      id="o-nas"
      data-testid="about-section"
      className="relative py-24 sm:py-36 bg-[#0a0a0a]"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-12 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20">
        {/* Left text */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="lg:col-span-5"
        >
          <span className="ornament mb-6">O nás</span>
          <h2 className="font-serif font-light text-4xl sm:text-5xl leading-[1.05] tracking-tight text-cream mt-6">
            Príbeh, ktorý si zaslúži
            <br />
            <em className="text-gold italic font-light">
              nezabudnuteľnú jazdu.
            </em>
          </h2>
          <div className="mt-10 space-y-5 text-cream/70 text-base leading-relaxed font-light max-w-md">
            <p>
              Tatra 603 je vrcholom československého dizajnu a inžinierstva.
              Aerodynamická línia, charakteristické štyri svetlomety a vzduchom
              chladený osemvalec robia z tohto vozidla skutočnú legendu.
            </p>
            <p>
              S láskou sa staráme o našu Tatru už viac ako dve desaťročia. Každý
              detail je v pôvodnom stave, každá jazda je obradom — niečím, čo si
              budete pamätať celý život.
            </p>
            <p>
              Nepožičiavame len auto. Požičiavame zážitok, ktorý zostáva v
              srdci aj na fotografiách.
            </p>
          </div>

          <div className="mt-10 pt-8 border-t border-white/10">
            <span className="text-[10px] uppercase tracking-[0.3em] text-gold/80">
              Majitelia
            </span>
            <div className="mt-4 flex flex-wrap gap-x-10 gap-y-2 font-serif text-xl text-cream">
              <span data-testid="owner-marek">Marek Mistina</span>
              <span className="text-cream/30">·</span>
              <span data-testid="owner-david">Dávid Mistina</span>
            </div>
          </div>

          <div className="mt-12 grid grid-cols-2 gap-x-8 gap-y-6">
            {stats.map((s) => (
              <div key={s.label} className="border-t border-white/10 pt-4">
                <div className="font-serif text-3xl text-gold font-light">
                  {s.value}
                </div>
                <div className="text-[11px] uppercase tracking-[0.25em] text-cream/50 mt-2">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </motion.div>

        {/* Right image collage */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.9, delay: 0.15 }}
          className="lg:col-span-7 relative min-h-[520px]"
        >
          <div className="absolute top-0 right-0 w-[78%] h-[440px] overflow-hidden border border-white/10">
            <img
              src={INTERIOR_IMG}
              alt="Historická Tatra 603 v Prahe"
              className="w-full h-full object-cover hover:scale-105 transition-transform duration-[1.4s] ease-out"
            />
          </div>
          <div className="absolute -bottom-0 left-0 w-[55%] h-[280px] border border-gold/30 bg-[#111111] overflow-hidden grain">
            <div className="p-8 h-full flex flex-col justify-between">
              <span className="text-[10px] uppercase tracking-[0.35em] text-gold">
                Pôvod
              </span>
              <div>
                <div className="font-serif text-2xl text-cream leading-tight">
                  Kopřivnice,
                  <br />
                  <em className="text-gold italic font-light">
                    Československo
                  </em>
                </div>
                <p className="text-xs text-cream/50 mt-3 leading-relaxed">
                  Vyrábaná v rokoch 1956 – 1975. Vrchol éry, ktorú už dnes
                  nikto nezopakuje.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
